module.exports = __webpack_public_path__ + "img/deaf_guide.6ed6e395.png";